<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "Content"
}
</script>

<style scoped>

</style>